import React from "react";
import { AttentionSeeker, Slide } from "react-awesome-reveal";

import "./Journey.css";

const Journey = () => {
  return (
    <div id="journey" className="journey">
      <div className="d-flex justify-content-center my-5">
        <AttentionSeeker effect="heartBeat" duration="1500">
          <h1 className="title">expedition</h1>
        </AttentionSeeker>
      </div>

      <div className="container journey-wrapper">
        <Slide cascade direction="right" duration="800">
          <div className="timeline-block timeline-block-right">
            <div className="marker"> </div>
            <div className="timeline-content">
              <h3>Accenture, 2024-Present </h3>
              <p>
                <b>Senior Software Engineer at Accenture </b>
                <br />
                Working for Disney on Java 17, GCP and MongoDB. 
              </p>
            </div>
          </div>
          <div className="timeline-block timeline-block-left">
            <div className="marker"> </div>
            <div className="timeline-content">
              <h3>Infibeam Avenues, 2021-2024 </h3>
              <p>
                <b>Software Programmer at Infibeam Avenues Ltd </b>
                <br />
                Worked on CCAvenue payment gateway system for banking integrations
              </p>
            </div>
          </div>
          <div className="timeline-block timeline-block-right">
            <div className="marker"></div>
            <div className="timeline-content">
              <h3>CDAC, 2020-2021 </h3>
              <p>
                <b>Diploma in Advance Computing from C-DAC ACTS, Pune</b> <br />
                Secured 2nd position across all centres
              </p>
            </div>
          </div>
          {/* <div className="timeline-block timeline-block-right">
            <div className="marker"></div>
            <div className="timeline-content">
              <h3>2019, PD1</h3>
              <p>
                <b>Salesforce Certified Platform Developer I</b>
              </p>
            </div>
          </div> */}
          <div className="timeline-block timeline-block-left">
            <div className="marker"></div>
            <div className="timeline-content">
              <h3>B.E, 2015-2019</h3>
              <p>
                <b>Bachelor of Engineering in Information Technology</b> <br />
                Pursued graduation from RTM Nagpur University
              </p>
            </div>
          </div>
          <div className="timeline-block timeline-block-right">
            <div className="marker"></div>
            <div className="timeline-content">
              <h3>HSC, 2015 </h3>
              <p>
                <b>Higher Secondary Certificate from MSBSHSE, Pune</b>
              </p>
            </div>
          </div>
        </Slide>
      </div>
    </div>
  );
};

export default Journey;
